import { ThemeName } from '../../../../config/themes/types/themeName';
import { useConfigContext } from '../../../../contexts/ConfigContext/ConfigContext';
import { Logo as CustomLogo } from './Logos/CustomLogo';
import { NeutralLogo } from './Logos/NeutralLogo';

export function Logo() {
  const {
    state: { themeName },
  } = useConfigContext();

  if (!themeName) {
    return null;
  }

  switch (themeName) {
    case ThemeName.neutral:
      return <NeutralLogo />;
    default:
      return <CustomLogo />;
  }
}
